module.exports = __webpack_public_path__ + "static/media/021.15ea71b8.jpg";